<template>
  <base-box class="d-flex flex-grow flex-column" v-bind="$attrs">
    <div class="d-flex justify-between align-start mb_25">
      <p class="account-title">Histórico de transações (2020)</p>
      <base-button text="FILTRAR ANO" />
    </div>
    <div class="flex relative">
      <div :class="{ 'absolute w-100 h-100 ofy-scroll pr-15': !isMobile }">
        <div
          v-for="(payment, paymentIndex) in paymentsList"
          :key="paymentIndex"
          :class="payment.statusClass"
          class="pt_30 pb_25"
        >
          <div class="d-flex align-center" :class="{ 'flex-wrap': isMobile }">
            <div class="p_flag mr_20"></div>
            <div class="p_label flex">
              <span class="p_date">{{ payment.date }}</span>
              - {{ payment.status_label }}
            </div>
            <div
              :class="{
                'w-100': isMobile,
                'd-flex justify-center mt_40': isMobile,
              }"
            >
              <base-button
                v-if="openedIndex != paymentIndex"
                class="payment-action p_0"
                @click="openedIndex = paymentIndex"
                >VER DETALHES</base-button
              >
              <base-button
                v-else
                class="payment-action p_0"
                @click="openedIndex = null"
                >OCULTAR DETALHES</base-button
              >
            </div>
          </div>
          <div
            class="payment-info py_20 px_20 mt_20"
            :class="{ collapsed: openedIndex != paymentIndex }"
          >
            Conteúdos de detalhes + Download NFE
          </div>
        </div>
      </div>
    </div>
  </base-box>
</template>
<script>
import { mapState } from "vuex";
import BaseBox from "@/components/Box";
import BaseButton from "@/components/Button";

const monthNames = {
  1: "Janeiro",
  2: "Fevereiro",
  3: "Março",
  4: "Abril",
  5: "Maio",
  6: "Junho",
  7: "Julho",
  8: "Agosto",
  9: "Setembro",
  10: "Outubro",
  11: "Novembro",
  12: "Dezembro",
};

const paymentsApiList = [
  { status: "WAITING_PAYMENT", date: 202012 },
  { status: "PAYED", date: 202011 },
  { status: "PAYED", date: 202010 },
  { status: "PAYED", date: 202009 },
  { status: "PAYED", date: 202008 },
];

export default {
  components: { BaseBox, BaseButton },
  data() {
    return {
      openedIndex: null,
      paymentsList: [],
    };
  },
  mounted() {
    this.paymentsList = paymentsApiList.map(this.processPayment);
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
  methods: {
    processPayment(paymentItem) {
      let returnObj = {};

      const year = Math.round(paymentItem.date / 100);
      const month = paymentItem.date - year * 100;

      switch (paymentItem.status) {
        case "WAITING_PAYMENT":
          returnObj = {
            statusClass: "waiting-payment",
            color: "#EA919E",
            date: `${monthNames[month]} de ${year}`,
            status_label: "Pagamento pendente!",
          };
          break;
        case "PAYED":
          returnObj = {
            statusClass: "payed",
            color: "#85D2C1",
            date: `${monthNames[month]} de ${year}`,
            status_label: "Pagamento realizado!",
          };
          break;
      }

      return returnObj;
    },
  },
};
</script>
<style scoped>
.account-title {
  color: var(--default);
  font-size: 16px;
  font-weight: 600;
  opacity: 0.8;
}

.collapsed {
  display: none;
}

.waiting-payment,
.payed {
  border-top: 0.2px solid #99999955;
}

.waiting-payment:last-child,
.payed:last-child {
  border-bottom: 0.2px solid #99999955;
}

.waiting-payment .p_flag {
  width: 25px;
  height: 25px;
  background: #ea919e 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.waiting-payment .p_date {
  text-align: left;
  font: normal normal bold 14px/17px Lato;
  letter-spacing: 0px;
  color: #ea919e;
  opacity: 1;
}

.waiting-payment .p_label {
  text-align: left;
  font: normal normal 300 15px/18px Lato;
  letter-spacing: 0px;
  color: #ea919e;
  opacity: 1;
}

.payed .p_flag {
  width: 25px;
  height: 25px;
  background: #85d2c1 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.payed .p_date {
  text-align: left;
  font: normal normal bold 14px/17px Lato;
  letter-spacing: 0px;
  color: #85d2c1;
  opacity: 1;
}

.payed .p_label {
  text-align: left;
  font: normal normal 300 15px/18px Lato;
  letter-spacing: 0px;
  color: #85d2c1;
  opacity: 1;
}

.payment-action {
  text-align: right;
  font: normal normal 300 12px/15px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}

.payment-info {
  background: #f9f9f9 0% 0% no-repeat padding-box;
  text-align: left;
  font: normal normal 300 12px/15px Lato;
  letter-spacing: 0px;
  color: #bbbbbb;
  opacity: 1;
}
</style>